import React, { useState } from "react";
import about from "./assets/img/about12.png";
import Primary from "./Primary";
import PrePrimaryPopup from "./PrePrimaryPopup";
import Primarypopup from "./Primarypopup";

const PrePrimary = () => {
  const [showAboutPopup, setshowAboutpopup] = useState(false);
  const handelOnClose = () => setshowAboutpopup(false);
  const [showPrimaryPopup, setShowPrimaryPopup] = useState(false);
  const handelOnClosePrimary = () => setShowPrimaryPopup(false);
  function handelOnClick() {
    console.log('true')
    setShowPrimaryPopup(true);
  }

  return (
    <div>

      <div className="container">
        <div className="row">
          <div className="col-lg-1 col-md-1 col-sm-12"></div>
          <div className="col-lg-5 col-md-5 col-sm-12">
            <p className="text-xl text-gray leading-7 w-[300px] mt-[13vw] ">
              <h1 className="font-bold text-[#8C1F1F] text-3xl">Pre Primary</h1> <br />
              Children (age 3 to 5 years) are generally motivated to learn about
              everything where they have a strong desire to find out and share
              information...
              <button
                onClick={() => setShowPrimaryPopup(true)}
                className="text-[#722828] bg-transparent font-bold"
              >
                Read More
              </button>
            </p>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12 ">
            <img src={about} alt="" className="" />
          </div>

        </div>
        <Primarypopup onClose={handelOnClosePrimary} visible={showPrimaryPopup} />
      </div>

    </div>

  );
};

export default PrePrimary;